const loadWhatFixScript = () => {
  const url = window.location.href;

  if (url.includes('localhost')) return;
  const isDev = url.includes('qa') || url.includes('dev');

  const script = document.createElement('script');
  script.src = isDev
    ? 'https://s.axsqa.com/whatfix/Event-Tool/embed/embed.nocache.js'
    : 'https://s.axs.com/whatfix/Event-Tool/embed/embed.nocache.js';

  script.language = 'javascript';
  script.type = 'text/javascript';
  script.async = 'true';
  document.body.appendChild(script);
};

export default loadWhatFixScript;



// WEBPACK FOOTER //
// ./src/common/scripts/whatFix.js